import Image from 'next/image'
import React from 'react'

import { cn } from '@/utilities/ui'

// next/image, not the shared `Logo`, which collapses to 50px here. 76x31 is the true aspect of the
// 88x36 source. See docs/unveiling.md#the-header-and-the-mobile-menu.
export function Wordmark({ className, priority }: { className?: string; priority?: boolean }) {
  return (
    <Image
      src="/assets-rebrand/logos/civo-white.svg"
      alt="Civo"
      width={76}
      height={31}
      priority={priority}
      className={cn('h-[31px] w-auto', className)}
    />
  )
}
